import React, { useState } from "react";
import { Modal, Form } from "react-bootstrap";
import CustomTooltip from "utils/CustomTooltip";
import showAlert from "utils/showAlert";

export default function BillingDashboardTableConfig(props) {
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [exportToSheets, setExportToSheets] = useState(props.org.spend_summary_export_to_google_sheets);
  const [googleSheetsUrl, setGoogleSheetsUrl] = useState(props.org.spend_summary_export_url);
  const [includeErrorStatus, setIncludeErrorStatus] = useState(props.org.spend_summary_export_include_error_status);

  const hideModal = () => setIsModalVisible(false);

  const handleExport = async () => {

    try {
      const response = await fetch('/datapulse/spend-summary-report/export-to-sheets', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': authenticityToken,
        },
        body: JSON.stringify({
          org_id: props.org.id,
          google_sheets_url: googleSheetsUrl,
          include_error_status: includeErrorStatus,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          console.log("Export successful:", data.message);
          showAlert(data.message, "success");
        } else {
          console.error("Export failed:", data.message);
          showAlert(data.message, "danger");
        }
      } else {
        const data = await response.json();
        if (data && data.message) {
          console.error("Failed to export data:", data.message);
          showAlert(data.message, "danger");
        } else {
          console.error("Failed to export data. No message from server");
          showAlert("Failed to export data", "danger");
        }
      }
    } catch (error) {
      console.error("Network error:", error);
      showAlert("Network error", "danger");
    }
    hideModal();
  };

  const handleSave = async () => {

    try {
      const response = await fetch('/datapulse/spend-summary-report/save-billing-table-config', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': authenticityToken,
        },
        body: JSON.stringify({
          org_id: props.org.id,
          export_to_sheets: exportToSheets,
          google_sheets_url: googleSheetsUrl,
          include_error_status: includeErrorStatus,
        }),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          console.log("Settings saved successfully:", data.message);
          showAlert(data.message, "success");
        } else {
          console.error("Failed to save settings:", data.message);
          showAlert(data.message, "danger");
        }
      } else {
        console.error("Failed to save settings. No message from server");
        showAlert("Failed to save settings", "danger");
      }
    } catch (error) {
      console.error("Network error:", error);
      showAlert("Network error", "danger");
    }
    hideModal();
  };

  return (
    <>
      <div style={{ cursor: "pointer" }} onClick={() => setIsModalVisible(true)}>
        <CustomTooltip
          faClass="fas fa-cog f18 pl-2"
          message="Configure spend report settings"
          inline={true}
        />
      </div>

      <Modal show={isModalVisible} onHide={hideModal} className="chart-help-modal">
        <Modal.Header closeButton>
          <Modal.Title>
            <h4>Spend Report Config</h4>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="mb-4 chart-help-modal-inner">
            <Form>
              <Form.Group controlId="exportToSheets">
                <Form.Check
                  type="checkbox"
                  label="Automatically export to google sheet?"
                  checked={exportToSheets}
                  onChange={(e) => setExportToSheets(e.target.checked)}
                />
              </Form.Group>

              <Form.Group controlId="googleSheetsUrl">
                <Form.Label>Google sheet URL</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Google Sheet URL"
                  value={googleSheetsUrl}
                  onChange={(e) => setGoogleSheetsUrl(e.target.value)}
                />
              </Form.Group>

              <Form.Group controlId="includeErrorStatus">
                <Form.Check
                  type="checkbox"
                  label="Include datapull error status?"
                  checked={includeErrorStatus}
                  onChange={(e) => setIncludeErrorStatus(e.target.checked)}
                />
              </Form.Group>
            </Form>
          </div>

          <div className="chart-help-modal-buttons" style={{ gap: "16px" }}>
            <button
              type="button"
              className="button b-type-primary b-size-normal"
              onClick={handleExport}
            >
              Export now
            </button>

            <button
              type="button"
              className="button b-type-primary b-size-normal b-color-green"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </Modal.Body>

      </Modal>
    </>
  );
}
